module.exports = __webpack_public_path__ + "static/img/mai-logo.d780971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mai-logo.png
// module id = 7lmE
// module chunks = 1